import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthError } from './state/auth.state';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly store: Store) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err?.status === 401) {
          this.store.dispatch(new AuthError());
        }

        return throwError(() => err);
      }),
    );
  }
}
